module.exports = __webpack_public_path__ + "static/media/47_A.7882cb3d.png";